import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { LinearProgress } from '@mui/material'
import { getLanguages, getRelationshipTypes } from 'store/lookup'
import ContactForm from './Form'
import ContactChangeForm from './ContactChangeForm'

export default function ContactsFormIndex({ memberId, contact, seq, own, isPrimary, onClose, onSaved }) {
  const dispatch = useDispatch()
  const relationshipTypes = useSelector(state => state.lookup.relationshipTypes)
  const languages = useSelector(state => state.lookup.languages)

  useEffect(() => {
    relationshipTypes || dispatch(getRelationshipTypes())
    languages || dispatch(getLanguages())
  }, [dispatch])

  if (!(relationshipTypes && languages)) return <LinearProgress />

  if (own) {
    return (
      <ContactChangeForm
        key={contact?.id}
        memberId={memberId}
        data={contact}
        isPrimary={isPrimary}
        onClose={onClose}
        onSaved={onSaved}
      />
    )
  }

  return (
    <ContactForm
      key={contact?.id ?? 'new'}
      memberId={memberId}
      data={contact}
      seq={seq}
      onClose={onClose}
      onSaved={onSaved}
    />
  )
}
